export default __webpack_public_path__ + "media/dc_card.7ba226c5.mov";